//v-if="!runAbTest || runAbTest && $exp.name == abTestName && $exp.$activeVariants[0].name == abTestVariantName"
<template>
  <div
    v-if="abTesting"
    class="c-column"
    :class="gridItemClass"
    :style="{
      backgroundImage: (
        backgroundImage &&
        backgroundImage.src &&
        `url(${backgroundImage.src})`
      ),
      backgroundSize:'cover'
    }"
  >
    <h2
      v-if="title"
      class="t-heading-2 u-text-align-center"
      :class="titleClass"
    >
      {{ title }}
    </h2>
    <h3
      v-if="subtitle"
      class="t-heading-2 u-text-align-center"
      :class="subtitleClass"
    >
      {{ subtitle }}
    </h3>
    <Wysiwyg
      v-if="description"
      :class="descriptionClass"
      :paragraph-size="descriptionTypography"
      :html="description"
    />
    <component
      :is="type"
      v-bind="data"
      :get-product-function="getProductFunction"
    />
  </div>
</template>

<script>
import BackgroundContentCard from "../card/BackgroundContentCard";
import ContentCard from "../card/ContentCard";
import get from 'lodash/get'
import ImageLayeredCard from "../card/ImageLayeredCard";
import isMobile from '@mixins/isMobile';
import ReviewCard from "../card/ReviewCard";
import ContentProductCard from "../card/ContentProductCard";
import StickerCard from '../card/StickerCard'
import Wysiwyg from "../wysiwyg/Wysiwyg";
export default {
  name: 'Column',
  components: {
    BackgroundContentCard,
    ContentCard,
    ImageLayeredCard,
    ReviewCard,
    Wysiwyg,
    ContentProductCard,
    StickerCard,
  },
  mixins: [
    //this.isMobile is true screen width < 900px
    isMobile
  ],
  props: {
    column: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: null
    },
    titleTypography: {
      type: String,
      default: "t-heading-2"
    },
    titleMarginBottom: {
      type: String,
      default: ""
    },
    titleColor: {
      type: String,
      default: ""
    },
    textAlignment: {
      type: String,
      default: "center"
    },
    mobileTextAlignment: {
      type: String,
      default: "center"
    },
    subtitle: {
      type: String,
      default: null
    },
    subtitleMarginBottom: {
      type: String,
      default: ""
    },
    subtitleTypography: {
      type: String,
      default: "t-heading-3"
    },
    subtitleColor: {
      type: String,
      default: ""
    },
    numberOfColumns: {
      type: Number,
      default: 1
    },
    backgroundImage: {
      type: Object,
      default: () => ({})
    },
    description: {
      type: String,
      default: ''
    },
    descriptionMarginBottom: {
      type: String,
      default: ""
    },
    descriptionTypography: {
      type: String,
      default: "t-paragraph"
    },
    descriptionColor: {
      type: String,
      default: 'base'
    },
    getProductFunction: {
      type: Function,
      default: () => {}
    },
    runAbTest: {
      type: Boolean,
      default: false
    },
    abTestName: {
      type: String,
      default: ''
    },
    abTestVariantName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      gridItemClass: "",
      isMobile: false
    }
  },
  computed: {
    type () {
      const column = this.column
      //console.log('testing card', column.card.type)
      const result = get(column, 'card.type', '').replace(/\s+/g, '-').toLowerCase()
      if(result === 'review-card' && !column.card.showReviewCard) {
        this.$emit('hideRow');
      }
      return result;
    },
    data () {
      return this.column.card
    },
    titleClass() {
      let results = ['']
      results.push(this.titleTypography);
      if (this.titleColor) {
        results.push(this.titleTypography + '--' + this.titleColor);
      }
      results.push('u-margin-bottom-' + this.titleMarginBottom);
      if (this.isMobile) {
        if (this.mobileTextAlignment) {
          results.push("u-text-align-" + this.mobileTextAlignment)
        }
      } else {
        results.push("u-text-align-" + this.textAlignment)
      }
      return results;
    },
    subtitleClass() {
      let results = ['']
      results.push(this.subtitleTypography);
      if (this.subtitleColor) {
        results.push(this.subtitleTypography + '--' + this.subtitleColor);
      }
      results.push('u-margin-bottom-' + this.subtitleMarginBottom);
      if (this.isMobile) {
        if (this.mobileTextAlignment) {
          results.push("u-text-align-" + this.mobileTextAlignment)
        }
      } else {
        results.push("u-text-align-" + this.textAlignment)
      }
      return results;
    },
    descriptionClass() {
      let descriptionColor = this.descriptionColor;
      let results = ['u-text-align-center']
      results.push(this.descriptionTypography);
      if (descriptionColor) {
        results.push('t-paragraph' + (this.descriptionTypography == 'regular'? '' : ('-' + this.descriptionTypography)) + '--' + descriptionColor);
      }
      results.push('u-margin-bottom-' + this.descriptionMarginBottom);
      return results;
    },
    abTesting() {
      let runAbTest = this.runAbTest;
      let abTestName = this.abTestName;
      let abTestVariantName = this.abTestVariantName;
      let $exp = this.$exp;
      return (!runAbTest || runAbTest &&
          $exp.name == abTestName &&
          $exp.$activeVariants[0].name == abTestVariantName)
    }
  },
  watch: {
    isMobile() {
      this.calculateGridItemClass();
    },
  },
  created() {
    try {
      window.addEventListener("resize", this.updateMobile);
    } catch (err) {
      // console.log('window not loaded');
    }
  },
  mounted() {
    this.calculateGridItemClass();
    this.updateMobile();
  },
  destroyed() {
    try {
      window.removeEventListener("resize", this.updateMobile);
    } catch (err) {
      // console.log('window not loaded');
    }
  },
  methods: {
    updateMobile() {
      const numberOfColumns = this.numberOfColumns;
      if (numberOfColumns == 3) {
        if (window.innerWidth <= 1200) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      }
      else {
        if (window.innerWidth <= 600) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      }

    },
    calculateGridItemClass() {
      const column = this.column
      const isMobile = this.isMobile
      const type = this.type
      let gridItemClass = 'l-grid__item'
      if (column.columnSpan > 1) {
        gridItemClass += " l-grid__item--span-" + column.columnSpan
      }
      if (column.mobileDisplayOrder && isMobile) {
        gridItemClass += " l-grid__item--row-" + column.mobileDisplayOrder
      }
      if (type == "background-content-card") {
        gridItemClass += " u-100-height"
      }
      this.gridItemClass = gridItemClass;
    }
  },
};
</script>

<style lang="scss" scoped>
  .c-column {
    padding-top: rem(10px);
    padding-bottom: rem(10px);
  }
</style>
